<template>
  <div>
    <div v-if="loading" class="push-down">
      <i class="spinner" />
    </div>
    <div v-if="anyChanges">
      <changes
        v-show="anyChanges"
        :value="modelValue"
        :changes-label="modelValue.ChangesLabel"
        :padding="false"
      />

      <hr class="big-margin" />
    </div>
    <price-line
      :label="modelValue.CurrentPriceLabel"
      :any-changes="anyChanges"
      :price="initialPriceFormatted"
      :payment-period-label="modelValue.PaymentPeriodLabel"
    />
    <price-line
      class="push-up"
      :label="modelValue.NewPriceLabel"
      :show-price="anyChanges && !loading"
      :any-changes="anyChanges"
      :price="price"
      :payment-period-label="modelValue.PaymentPeriodLabel"
      :emphasize="true"
    />

    <p v-if="inRenewal && editMode" class="push-up" v-html="modelValue.RenewalText" />

    <p v-if="shouldBlock" class="warning push-up" v-html="basketErrorText" />
  </div>
</template>
<script>
import BasketMixin from './_BasketMixin';
import Changes from './Changes.vue';
import PriceLine from './PriceLine.vue';

export default {
  name: 'ShowPrices',
  components: {
    PriceLine,
    Changes
  },
  mixins: [BasketMixin],
  props: {
    modelValue: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  computed: {
    loading() {
      return this.$store.state.policy.loading;
    },
    inRenewal() {
      return this.$store.getters['policy/inRenewal'];
    }
  }
};
</script>
